import { render, staticRenderFns } from "./AdminBrandsTable.vue?vue&type=template&id=64fac37e"
import script from "./AdminBrandsTable.vue?vue&type=script&lang=js"
export * from "./AdminBrandsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64fac37e')) {
      api.createRecord('64fac37e', component.options)
    } else {
      api.reload('64fac37e', component.options)
    }
    module.hot.accept("./AdminBrandsTable.vue?vue&type=template&id=64fac37e", function () {
      api.rerender('64fac37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminBrandsTable.vue"
export default component.exports